module.exports = __webpack_public_path__ + "041f3ddbc60df2cad12ef84f02eb7c77.jpg";